import { setupRouter } from "./routes/router";
import { routeTree } from "./routes/routes";

setupRouter(document.body, routeTree);
